export default {
  ADD_PAYMENT_METHOD: {
    scope: 'payment_method',
  },
  DELETE_PAYMENT_METHOD: {
    scope: 'payment_method',
  },
  MARK_PAYMENT_METHOD_PRIMARY: {
    scope: 'payment_method',
  },
  FIND_PAYMENT_METHOD: {
    scope: 'payment_method:read',
  },
  FIND_PAYMENT_METHODS: {
    scope: 'payment_method:read',
  },
};
